import classes from './Alert.module.scss'
import type { ReactNode } from 'react'

type AlertType = 'success' | 'none' | 'default' | 'information'

export interface Props {
  variant?: AlertType
  children: ReactNode
}

const Alert = ({
  children,
  variant = 'default'
}: Props) => {

  const getClasses = (type: AlertType) => [
    classes.Alert,
    classes[type]
  ].filter(classStyle => classStyle).join(' ')

  return (
    <div className={getClasses(variant)}>
      {children}
    </div>
  )
}

export default Alert
